<template>
  <div class="container">
    <h3  v-text="articleInfo.title"></h3>
    <div class="date">发布时间：{{articleInfo.create_time | strSplit(0,10)}}</div>
    <p class="rich-text-content content" v-html="articleInfo.content"></p>
    <div v-if="articleInfo.fileList&&articleInfo.fileList.length>0">
      <p>附件：</p>
      <p v-for="(item, index) in articleInfo.fileList" :key="index"><a :download="item.file_name" :href="baseDomain+item.file_path">{{item.file_name}}</a></p>
    </div>
  </div>
</template>

<script>
import {selectArticleDetails} from '../../api/article/selectArticleDetails'  // 查文章详情
import {baseDomain} from '../../api/baseDomain'
export default {
  data() {
    return {
      articleInfo: {},
      baseDomain
    }
  },
  methods: {
    getArticleDetails() {
      selectArticleDetails({articleId:this.$route.params.articleid}).then(res => {
        this.articleInfo = res.data[0]
      }).catch(() => {

      })
    }
  },
  created() {
    this.getArticleDetails()
  }
}
</script> 

<style lang="scss" scoped>
  @import '../../assets/css/default.scss';
  .container {
    width: 1000px;
    margin: 30px auto;
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      color: #000;
      padding: 10px 0;
    }
    .date {
      font-size: 14px;
    }
  }
  @media screen and(max-width: 1200px) {
    .container {
      width: 800px;
    }
  }

  @media screen and(max-width: 768px) {
    .container {
      width: 90%;
      /deep/ * {
        max-width: 100% !important;
        white-space: initial;
      }
      h3 {
        text-align: left;
      }
    }
  }
</style>